import React, { useState, useEffect } from 'react';
import { SideNavMenu, SideNavMenuItem } from 'carbon-components-react';
import { Star16 } from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';
import { APP_URL } from 'types';
import { isEndUserPremiumPath } from 'utilities/premium-nav.util';

export const LeftNavPremiumFeatures: React.FC = () => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);

  const isPremiumMenuActive = isEndUserPremiumPath(pathname);

  return (
    <SideNavMenu
      renderIcon={Star16}
      title="Premium features"
      isActive={isPremiumMenuActive}
      defaultExpanded={isPremiumMenuActive}
    >
      <SideNavMenuItem
        isActive={pathname === APP_URL.PREMIUM_SELF_SERVICE}
        onClick={() => history.push(APP_URL.PREMIUM_SELF_SERVICE)}
      >
        Overview
      </SideNavMenuItem>
      <SideNavMenuItem
        isActive={pathname === APP_URL.BULK_ENQUIRY_LODGEMENT}
        onClick={() => history.push(APP_URL.BULK_ENQUIRY_LODGEMENT)}
      >
        Large area enquiries
      </SideNavMenuItem>
      <SideNavMenuItem
        isActive={pathname === APP_URL.BYDA_MEMBER_LOOKUP}
        onClick={() => history.push(APP_URL.BYDA_MEMBER_LOOKUP)}
      >
        BYDA member lookup
      </SideNavMenuItem>
      <SideNavMenuItem
        isActive={pathname === APP_URL.PURCHASE_TRANSACTIONS}
        onClick={() => history.push(APP_URL.PURCHASE_TRANSACTIONS)}
      >
        Purchase transactions
      </SideNavMenuItem>
    </SideNavMenu>
  );
};

export default LeftNavPremiumFeatures;
